/* eslint-disable react/jsx-wrap-multilines */

import React from 'react'
import { Paragraph, Box, Heading, ResponsiveContext } from 'grommet'
import CalendarConfigContext from './CalendarConfigContext'

const CalendarListHeader = () => (
  <CalendarConfigContext.Consumer>
    {appConfig => (
      <ResponsiveContext.Consumer>
        {size => (
          <Box
            a11yTitle="Calendar events title"
            align="center"
            justify="center"
            pad="small"
          >

            <Heading size="small" align="right" a11yTitle="New Events title">
              Questions about an Event?
            </Heading>

            <Paragraph size="small" align="right">
	      Check details for each event for times and descriptions, and entry fees, if required.
	    </Paragraph>

            <Heading size="small" align="right" a11yTitle="New Events subtitle">
              Have an Event to Add?
            </Heading>

            <Paragraph size="small" align="right">
              Please use the contact form to tell us about an event to list.
	    </Paragraph>

          </Box>
        )}
      </ResponsiveContext.Consumer>
    )}
  </CalendarConfigContext.Consumer>
)

export default CalendarListHeader
